import getResourceField from '@/components/query/adapters/criteria/get-resource-field';
import {getSpecialResourceFieldPath} from '@/common/api/definitions/special/special-fields';

/**
 * Resolve the field being displayed form its path or operator
 * @param path {string}
 * @param op {string|null}
 * @return {Object}
 */
export default function getField({path, op = null}) {
    let resolvedPath = path;
    // no path indicates a special field
    if (path === null && op !== null) {
        resolvedPath = getSpecialResourceFieldPath({op});
    }
    // otherwise it's an API field
    return getResourceField(resolvedPath, this.groups);
}
